<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.addonStart) {
    <span
      class="input-group-text"
      [ngClass]="props.addonStartClass"
      >
      {{ props.addonStart }}
    </span>
  }

  <input
    class="form-control"
    [type]="props.inputType ?? 'text'"
    [formControl]="$any(formControl)"
    [placeholder]="props.placeholder"
    [formlyAttributes]="field"
    [attr.data-testid]="props.testId"
    />

  @if (props.addonEnd) {
    <span
      class="input-group-text"
      [ngClass]="props.addonEndClass"
      >
      {{ props.addonEnd }}
    </span>
  }

  @if (props.addonEndButton) {
    <button
      class="btn btn-colour-blue-600"
      type="button"
      (click)="props.addonEndButton.clickAction()"
      >
      {{ props.addonEndButton.text }}
    </button>
  }
</div>
